import { TFunction } from "i18next";
import { SecondaryColor, SemanticColor } from "node-library/dist/colors";
import {
	BatchStatus,
	FrontendTestBatchStatusFilter,
} from "node-library/dist/constants";
import { AnalystCustomGroup } from "node-library/dist/database";
import {
	TestBatchSortColumn,
	UnionTestBatchSortColumn,
} from "node-library/dist/paginations";
import {
	FrontendAnalystCustomGroup,
	FrontendBatchType,
	FrontendCompanyWithAdditionalInfomation,
} from "node-library/dist/portal";

export function getBatchStatusTranslationString(
	status: BatchStatus,
	translation: TFunction<"translation", undefined>
): string {
	switch (status) {
		case BatchStatus.UNSTARTED:
			return translation("Unstarted");
		case BatchStatus.IN_PROGRESS:
			return translation("InProgress");

		case BatchStatus.PENDING_RESULT_VALIDATION:
			return translation("Validating");
		case BatchStatus.COMPLETE:
			return translation("Complete");
	}
}

export function getBatchStatusFilterTranslationText(
	status: FrontendTestBatchStatusFilter,
	translation: TFunction<"translation", undefined>
) {
	switch (status) {
		case FrontendTestBatchStatusFilter.IN_PROGRESS:
			return translation("InProgress");
		case FrontendTestBatchStatusFilter.COMPLETE:
			return translation("Complete");
		case FrontendTestBatchStatusFilter.ALL:
			return translation("All");
	}
}
export function getBatchStatusColors(status: BatchStatus): {
	backgroundColor: string;
	borderColor: string;
	textColor: string;
} {
	switch (status) {
		case BatchStatus.UNSTARTED:
			return {
				backgroundColor: SemanticColor.WARNING_100,
				borderColor: SemanticColor.WARNING,
				textColor: SemanticColor.WARNING_300,
			};
		case BatchStatus.PENDING_RESULT_VALIDATION:
			return {
				backgroundColor: SemanticColor.ERROR_100,
				borderColor: SemanticColor.ERROR_MEDIUM,
				textColor: SemanticColor.ERROR_300,
			};
		case BatchStatus.IN_PROGRESS:
			return {
				backgroundColor: SecondaryColor.SECONDARY_100,
				borderColor: SecondaryColor.SECONDARY_500,
				textColor: SecondaryColor.SECONDARY_600,
			};
		case BatchStatus.COMPLETE:
			return {
				backgroundColor: SemanticColor.SUCCESS_100,
				borderColor: SemanticColor.SUCCESS,
				textColor: SemanticColor.SUCCESS_300,
			};
	}
}

export function getTestBatchSortString(
	column: TestBatchSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (column) {
		case TestBatchSortColumn.DUE_DATE:
			return translation("DueDate");
		case TestBatchSortColumn.INSERTED:
			return translation("Createdon");
	}
}
export function getUnionTestBatchSortString(
	column: UnionTestBatchSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (column) {
		case UnionTestBatchSortColumn.DUE_DATE:
			return translation("DueDate");
		case UnionTestBatchSortColumn.INSERTED:
			return translation("Createdon");
	}
}

export function findCompanyBatchTypeById(
	company: FrontendCompanyWithAdditionalInfomation,
	testCategoryId: string,
	batchTypeId: string
): FrontendBatchType | undefined {
	for (const category of company.companyTestCategories) {
		if (category.testCategoryId != testCategoryId) {
			continue;
		}
		const match = category.batchTypes.find(
			(bt) => bt.batchTypeId === batchTypeId
		);
		if (match) {
			return match;
		}
	}
	return undefined;
}

export function getDefaultOtherTestBatchType(
	testCategoryId: string,
	translation: TFunction<"translation", undefined>
) {
	const otherTestBatch: FrontendBatchType = {
		batchTypeId: "other",
		testCategoryIds: [testCategoryId], // or "" if it shouldn't belong to any
		batchName: translation("OtherTesting"), // Make sure to add this to your i18n if not already
		testGroupNodeId: "other-group", // a unique string that won't conflict
		requireDuplicateInstance: false,
		testHierarchyNodeIds: [],
		testGroupOptionNodeIds: [],
		testMethodCode: "",
	};
	return otherTestBatch;
}
